import { CloseOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import { authSlice } from 'common/commonRedux/auth/slice';
import { PageTourProvider } from 'common/components';
import AccountStatusGate from 'common/components/AccountStatusGate/AccountStatusGate';
import GuideWidget from 'modules/FullGuideTour/GuideWidget';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import './ResponsiveLayout.scss';
import Sidebar from './Sidebar/Sidebar/Sidebar';
import Topbar from './Topbar/Topbar';
// import useToken from 'antd/es/theme/useToken';
import { theme } from 'antd';
const { useToken } = theme;
export function MainLayout(props: any) {
  const { token } = useToken();
  const { auth } = useSelector((state: any) => state, shallowEqual);
  const { profileData, isMenuClicked } = useSelector(
    (state: any) => state?.auth
  );
  if (!auth.isAuth) {
    return <>{props.children}</>;
  }
  const dispatch: any = useDispatch();
  const { setIsMenuClicked } = authSlice.actions;
  useLocation();
  return (
    <PageTourProvider>
      <Layout className="relative">
        {/* Sidebar */}
        <Layout className="fixed z-[1000] xl:block hidden">
          <Sidebar />
        </Layout>
        {/* responsive sidebar */}
        {isMenuClicked && (
          <div
            className="fixed inset-0 bg-black/30 z-[999] xl:hidden"
            onClick={() => dispatch(setIsMenuClicked(false))}
          />
        )}
        <Layout
          className={`shadow-2xl fixed top-0 bottom-0 h-screen z-[1000] block xl:hidden ${isMenuClicked ? 'left-0' : '-left-[250px]'}`}
          style={{ transition: 'all .4s ease' }}
        >
          <button
            className="absolute top-3 right-3 z-10 w-8 h-8 flex justify-center items-center bg-primaryColor rounded text-white"
            onClick={() => dispatch(setIsMenuClicked(false))}
          >
            <CloseOutlined />
          </button>
          <Sidebar showOnMobile={true} />
        </Layout>
        {/* Main Content Layout */}
        <Layout
          style={{
            transition: 'margin-left 0.3s ease',
          }}
          className={`overflow-hidden h-[100vh] ${profileData?.getLayoutCollapsed ? ' xl:ml-[80px]' : 'xl:ml-[234px]'}`}
        >
          {/* Scrollable Content with sticky Topbar inside */}
          <div
            style={{
              background: `${token.colorBgBase}`,
              overflowY: 'auto',
              overflowX: 'hidden',
              flex: 1,
            }}
            onClick={() => {
              dispatch(setIsMenuClicked(false));
            }}
          >
            {/* Topbar is sticky inside this scroll container */}
            <Topbar />
            {props.children}
          </div>
        </Layout>
        <AccountStatusGate />
        <GuideWidget />
      </Layout>
    </PageTourProvider>
  );
}
